// A deliberate sideways swipe on `target` (Home → Newsstand, Cover → back).
// Touches that start near a screen edge are left alone so Android's
// back gesture never fires both; so are inputs, open modals and drags.

const EDGE = 28;
const MIN_DX = 70;

export function isSwipe(dx, dy, minDx = MIN_DX) {
	return Math.abs(dx) >= minDx && Math.abs(dx) > Math.abs(dy) * 1.5;
}

export function onSwipe(target, { left, right, allow = () => true } = {}) {
	let start = null;
	target.addEventListener("touchstart", (e) => {
		start = null;
		if (e.touches.length !== 1) return;
		const t = e.touches[0];
		if (t.clientX < EDGE || t.clientX > window.innerWidth - EDGE) return;
		if (e.target.closest?.("input, textarea, select, .modal-overlay, .drawer, .notif-panel")) return;
		if (document.body.classList.contains("dragging-rows") || document.querySelector('[data-selecting="1"]')) return;
		start = { x: t.clientX, y: t.clientY };
	}, { passive: true });
	target.addEventListener("touchend", (e) => {
		if (!start) return;
		const t = e.changedTouches[0];
		const dx = t.clientX - start.x;
		const dy = t.clientY - start.y;
		start = null;
		if (!isSwipe(dx, dy) || !allow(dx)) return;
		if (dx < 0) left?.();
		else right?.();
	}, { passive: true });
	target.addEventListener("touchcancel", () => { start = null; }, { passive: true });
}
